// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Alert,
  Paper,
  Select,
  FormControl,
  MenuItem,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";

import { LIST_POST } from "../../config/const";
// jotai
import { useWindowSize } from "../../lib/useWindowSize";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface FollowCallModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  callDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_status: number | null;
    follow_call_hope_date: string;
    follow_call_hope_time: string;
    follow_call_memo: string;
  };
  setCallDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_status: number | null;
    follow_call_hope_date: string;
    follow_call_hope_time: string;
    follow_call_memo: string;
  }) => void;
  callData: () => void;
}

export function FollowCallModal(props: FollowCallModalProps) {
  const { onModal, swCloseModal, callDataInf, setCallDataInf, callData } =
    props;

  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="follow-call-modal">
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="cancelTitleBox"
          className="shippori-antique-regular"
        >
          フォローコール
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          {callDataInf.status === "open" ? (
            <>
              <Paper elevation={0}>
                <Box
                  key="open1"
                  sx={{
                    maxHeight:
                      windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                    overflowY: windowWidth > 385 ? "auto" : undefined,
                  }}
                >
                  <Box className="serch-label">フォローコール結果</Box>
                  <Box key="servicePlanBox">
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <Select
                        labelId="serch-input-label"
                        id="serch-input-option"
                        data-testid="follow-call-result-select"
                        key={"servicePlanSelect"}
                        value={callDataInf.follow_call_status}
                        onChange={(e) => {
                          const follow_call_status = e.target.value as number;
                          setCallDataInf({
                            ...callDataInf,
                            follow_call_status,
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {LIST_POST.follow_call_status.map((follow_call, i) => {
                          return (
                            <MenuItem
                              key={"follow_call_status" + i}
                              value={follow_call.id}
                              sx={{
                                fontSize: "14px",
                                height:
                                  follow_call.value === "" ? "14px" : "24px",
                                minHeight: "auto",
                              }}
                            >
                              {follow_call.value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                  {callDataInf.follow_call_status === 4 ? (
                    <>
                      <Box className="serch-label">架電希望日</Box>
                      <Box key="hope_call_date">
                        <CustomTextField
                          id="hope_call_date"
                          size="small"
                          type="date"
                          value={callDataInf.follow_call_hope_date}
                          onChange={async (e) => {
                            setCallDataInf({
                              ...callDataInf,
                              follow_call_hope_date: e.target.value,
                            });
                          }}
                          sx={{
                            width: "calc(100% - 10px)",
                            margin: "10px 5px",
                          }}
                        />
                      </Box>
                      <Box className="serch-label">架電希望時間</Box>
                      <Box key="hope_call_time">
                        <CustomTextField
                          id="hope_call_time"
                          size="small"
                          value={callDataInf.follow_call_hope_time}
                          onChange={async (e) => {
                            setCallDataInf({
                              ...callDataInf,
                              follow_call_hope_time: e.target.value,
                            });
                          }}
                          sx={{
                            width: "calc(100% - 10px)",
                            margin: "10px 5px",
                          }}
                        />
                      </Box>
                    </>
                  ) : null}
                  {callDataInf.follow_call_status === 2 ||
                  callDataInf.follow_call_status === 4 ? (
                    <>
                      <Box className="serch-label">備考</Box>
                      <Box key="return_call_memo">
                        <CustomTextField
                          id="return_call_memo"
                          size="small"
                          value={callDataInf.follow_call_memo}
                          onChange={async (e) => {
                            setCallDataInf({
                              ...callDataInf,
                              follow_call_memo: e.target.value,
                            });
                          }}
                          sx={{
                            width: "calc(100% - 10px)",
                            margin: "10px 5px",
                          }}
                          multiline
                          rows={4}
                        />
                      </Box>
                    </>
                  ) : null}
                </Box>
              </Paper>
              <Box
                key="shozaiSelect"
                style={{ display: windowWidth > 385 ? "flex" : undefined }}
              >
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? undefined : "5px",
                  }}
                >
                  <Button
                    disabled={
                      callDataInf.follow_call_status === null
                        ? true
                        : callDataInf.follow_call_status === 4
                        ? callDataInf.follow_call_hope_date === "" ||
                          callDataInf.follow_call_hope_time === ""
                        : false
                    }
                    data-testid="follow-call-submit"
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    onClick={callData}
                  >
                    <Box className="m-plus-rounded-1c-regular">更新</Box>
                  </Button>
                </Box>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? "10px" : "5px",
                  }}
                >
                  <Button
                    data-testid="follow-call-back"
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    onClick={() => {
                      swCloseModal();
                    }}
                  >
                    <Box className="m-plus-rounded-1c-regular">戻る</Box>
                  </Button>
                </Box>
              </Box>
            </>
          ) : callDataInf.status === "success" ? (
            <>
              <Box className="shippori-antique-regular">成功しました。</Box>
              <Box>
                <Button
                  data-testid="follow-call-success-close"
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : callDataInf.status === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                {callDataInf.message}
              </Box>
              <Box>
                <Button
                  data-testid="follow-call-failed-back"
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() =>
                    setCallDataInf({
                      ...callDataInf,
                      status: "open",
                      message: "",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </>
          ) : null}
        </Typography>
      </Box>
    </Modal>
  );
}
